import React, { useEffect, useState } from "react";
import Dropdown from "./DropDown";
import FadeInComponent from "./FadeIn";
import { useController } from "react-hook-form";
import useWindowSize from "../../utils/hooks/useWindowSize";


const SelectDropDown = ({ label, name, control, error, options = [] }) => {
    const windowSize = useWindowSize();
    const [resetArtist, setResetArtist] = useState(false);
    const [resetRecruiter, setResetRecruiter] = useState(false);
    const { field } = useController({
        name,
        control,
        defaultValue: ""
    });

    const handleChange = (_, option) => {
        field.onChange(option.value);
    };

    return (
        <FadeInComponent>
            <div className="category-container">
                <label style={{ fontSize: 12, alignSelf: "flex-start", margin: "4px 0" }}>{label}</label>
                <Dropdown
                    key={name}
                    options={options}
                    placeholder="Select"
                    onChange={handleChange}
                />
                {error && <div className="error">{error}</div>}
            </div>
        </FadeInComponent>
    );
};

export default SelectDropDown;
